import { useEffect } from "react";
import useWindowFocus from "use-window-focus";

function useFocusEffect(cb) {
  let isFocused = useWindowFocus();

  useEffect(() => {
    if (isFocused) {
      cb();
    }
  }, [isFocused]);
}

export default useFocusEffect;
